import * as React from 'react'
export const SvgContentTwitter = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={40} height={40} {...props}>
    <path
      fill={props.fill || '#333'}
      d="M28.003 14.334a4.466 4.466 0 001.944-2.467c-.855.51-1.8.88-2.808 1.08a4.396 4.396 0 00-3.226-1.409c-2.439 0-4.417 2-4.417 4.463 0 .35.037.69.113 1.016-3.673-.187-6.928-1.96-9.11-4.664a4.502 4.502 0 00-.598 2.247c0 1.545.78 2.913 1.967 3.713a4.368 4.368 0 01-2.003-.557v.055c0 2.163 1.523 3.966 3.546 4.376a4.38 4.38 0 01-1.996.078c.563 1.772 2.194 3.062 4.128 3.098a8.82 8.82 0 01-5.489 1.91c-.356 0-.709-.02-1.054-.061a12.433 12.433 0 006.774 2.004c8.13 0 12.575-6.799 12.575-12.698 0-.193-.004-.387-.012-.577a8.97 8.97 0 002.204-2.31 8.724 8.724 0 01-2.538.703z"
    />
  </svg>
)
export default SvgContentTwitter
